module.exports = __webpack_public_path__ + "img/icon_clock.8694fe37.svg";